<template>
  <BlocoFormularioCadastro voltar="/medico" @salvar="salvar()">
    <template #form>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            :class="{
              'panel-primary': !v$.medico.$error,
              'panel-danger': v$.medico.$error,
            }"
            class="panel"
          >
            <div class="panel-heading"> Médico </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
                  <div
                    :class="{ 'has-error': v$.medico.nome.$error }"
                    class="form-group"
                  >
                    <label>Nome <sup>(1)</sup></label>
                    <input
                      id="nome"
                      v-model="medico.nome"
                      data-test-id="input-nome"
                      type="text"
                      name="nome"
                      placeholder="Nome do médico"
                      class="form-control"
                      @input="v$.medico.nome.$touch()"
                    />
                    <span v-if="v$.medico.nome.$dirty">
                      <span v-if="!v$.medico.nome.required" class="help-block"
                        >Campo obrigatório.</span
                      >
                      <span v-if="!v$.medico.nome.maxLength" class="help-block"
                        >Campo deve ter no máximo
                        {{ v$.medico.nome.$paramn.maxLength.max }} letras.</span
                      >
                    </span>
                  </div>
                </div>
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  <div
                    :class="{ 'has-error': v$.medico.cbo.$error }"
                    class="form-group"
                  >
                    <label for="cbo">CBO <sup>(1)</sup></label>
                    <select
                      id="cbo"
                      v-model="medico.cbo"
                      data-test-id="select-cbo"
                      name="cbo"
                      class="form-control"
                    >
                      <option disabled value="">Selecione</option>
                      <option v-for="cbo in cbos" :key="cbo.codigo" :value="cbo"
                        >{{ cbo.codigo }} - {{ cbo.valor }}</option
                      >
                    </select>
                    <span v-if="v$.medico.cbo.$dirty">
                      <span v-if="!v$.medico.cbo.required" class="help-block"
                        >Campo obrigatório.</span
                      >
                    </span>
                  </div>
                </div>
                <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                  <div
                    :class="{ 'has-error': v$.medico.ativo.$error }"
                    class="form-group"
                  >
                    <label>Situação <sup>(1)</sup></label>
                    <select
                      id="ativo"
                      v-model="medico.ativo"
                      data-test-id="select-ativo"
                      name="ativo"
                      class="form-control"
                    >
                      <option :value="true">Ativo</option>
                      <option :value="false">Cancelado</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div
            :class="{
              'panel-primary': !v$.medico.$error,
              'panel-danger': v$.medico.$error,
            }"
            class="panel"
          >
            <div class="panel-heading"> Filiação </div>
            <div class="panel-body">
              <div class="row">
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <div
                    :class="{ 'has-error': v$.medico.conselho.$error }"
                    class="form-group"
                  >
                    <label>Conselho <sup>(1)</sup></label>
                    <select
                      id="conselho"
                      v-model="medico.conselho"
                      data-test-id="select-conselho"
                      name="conselho"
                      class="form-control"
                    >
                      <option disabled value="">Selecione</option>
                      <option
                        v-for="conselho in conselhos"
                        :key="conselho.codigo"
                        :value="conselho.codigo"
                        >{{ conselho.codigo }} - {{ conselho.valor }}</option
                      >
                    </select>
                    <span v-if="v$.medico.conselho.$dirty">
                      <span
                        v-if="!v$.medico.conselho.required"
                        class="help-block"
                        >Campo obrigatório.</span
                      >
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <div
                    :class="{ 'has-error': v$.medico.ufConselho.$error }"
                    class="form-group"
                  >
                    <label>UF <sup>(1)</sup></label>
                    <select
                      id="ufConselho"
                      v-model="medico.ufConselho"
                      data-test-id="select-ufconselho"
                      name="ufConselho"
                      class="form-control"
                    >
                      <option disabled value="">Selecione</option>
                      <option
                        v-for="uf in ufs"
                        :key="uf.sigla"
                        :value="uf.sigla"
                        >{{ uf.sigla }}</option
                      >
                    </select>
                    <span v-if="v$.medico.ufConselho.$dirty">
                      <span
                        v-if="!v$.medico.ufConselho.required"
                        class="help-block"
                        >Campo obrigatório.</span
                      >
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                  <div
                    :class="{ 'has-error': v$.medico.numeroConselho.$error }"
                    class="form-group"
                  >
                    <label>Número conselho <sup>(1)</sup></label>
                    <input
                      id="numroConselho"
                      v-model="medico.numeroConselho"
                      v-mask="'9999999999999999999999999999999999999999'"
                      data-test-id="input-numroconselho"
                      type="text"
                      name="numroConselho"
                      placeholder="Número do conselho regional do médico"
                      class="form-control"
                      @input="v$.medico.numeroConselho.$touch()"
                    />
                    <span v-if="v$.medico.numeroConselho.$dirty">
                      <span
                        v-if="!v$.medico.numeroConselho.required"
                        class="help-block"
                        >Campo obrigatório.</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p>(1) Campos obrigatórios.</p>
    </template>
  </BlocoFormularioCadastro>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { maxLength, required } from '@vuelidate/validators'
import AwesomeMask from 'awesome-mask'

import BlocoFormularioCadastro from '@/componentes/formulario/BlocoFormularioCadastro'
import { useMenu } from '@/composables/useMenu'
import { dominioMixin } from '@/mixins/DominioMixin'
import router from '@/router'
import EstadoServico from '@/servicos/EstadoServico'
import MedicoServico from '@/servicos/MedicoServico'
import MensagemServico from '@/servicos/MensagemServico'

const medicoServico = new MedicoServico()
const mensagemServico = new MensagemServico()
const estadoServico = new EstadoServico()

export default {
  components: { BlocoFormularioCadastro },
  directives: { mask: AwesomeMask },
  mixins: [dominioMixin],
  setup() {
    useMenu(23)
    return { v$: useVuelidate() }
  },
  data() {
    return {
      conselhos: [],
      ufs: [],
      cbos: [],
      medico: {
        nome: '',
        conselho: '',
        cbo: '',
        numeroConselho: '',
        ufConselho: '',
        ativo: true,
      },
    }
  },
  validations: {
    medico: {
      nome: { required, maxLength: maxLength(80) },
      conselho: { required },
      cbo: { required },
      numeroConselho: { required },
      ufConselho: { required },
      ativo: { required },
    },
  },
  created() {
    this.recuperarMedico()
  },
  mounted() {
    this.recuperarValoresDominio('cbo').then((res) => {
      this.cbos = res.valores
    })
    this.recuperarValoresDominio('ConselhoProfissional').then((res) => {
      this.conselhos = res.valores
    })
    estadoServico.recuperarUfs().then((res) => {
      this.ufs = res.estados
    })
  },
  methods: {
    salvar() {
      this.v$.$touch()

      if (this.v$.medico.$invalid) {
        mensagemServico.cadastroInvalido(this.v$)
      } else {
        if (this.medico._id) {
          medicoServico
            .atualizar(this.medico._id, this.medico)
            .then((result) => {
              if (result.erro) {
                mensagemServico.alerta(result.erro.content, result.erro.title)
                return
              }

              router.replace({ name: 'Medicos' })
            })
        } else {
          medicoServico.criar(this.medico).then((result) => {
            if (result.erro) {
              mensagemServico.alerta(result.erro.content, result.erro.title)
              return
            }

            router.replace({ name: 'Medicos' })
          })
        }
      }
    },
    recuperarMedico() {
      const medicoId = this.$route.params.id

      if (medicoId) {
        medicoServico.recuperar(medicoId).then((result) => {
          this.medico._id = medicoId
          this.medico.nome = result.medico.nome
          this.medico.conselho = result.medico.conselho
          this.medico.cbo = result.medico.cbo
          this.medico.numeroConselho = result.medico.numeroConselho
          this.medico.ufConselho = result.medico.ufConselho
          this.medico.ativo = result.medico.ativo
        })
      }
    },
  },
}
</script>
